// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".avatar-delete-btn[data-v-49ea2f82] {\n  margin-top: var(--space-smaller);\n  margin-bottom: var(--space-smaller);\n}", "",{"version":3,"sources":["/app/app/javascript/dashboard/components/widgets/forms/AvatarUploader.vue"],"names":[],"mappings":"AACA;EACE,gCAAA;EACA,mCAAA;AAAF","file":"AvatarUploader.vue","sourcesContent":["\n.avatar-delete-btn {\n  margin-top: var(--space-smaller);\n  margin-bottom: var(--space-smaller);\n}\n"]}]);
// Exports
module.exports = exports;
